import { render, staticRenderFns } from "./anzera-power-chat.vue?vue&type=template&id=66d5d170&scoped=true"
import script from "./anzera-power-chat.vue?vue&type=script&lang=js"
export * from "./anzera-power-chat.vue?vue&type=script&lang=js"
import style0 from "./anzera-power-chat.scss?vue&type=style&index=0&id=66d5d170&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d5d170",
  null
  
)

export default component.exports